import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Valentina de Santiago', 'Camila de Buenos Aires', 'Mariana de Bogotá', 'Lucía de Montevideo', 'Fernanda de Lima', 'Gabriela de Ciudad de México', 'Sofía de Córdoba', 'Isabella de Medellín', 'Martina de Rosario', 'Daniela de Quito'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 4000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      setCurrentName(randomName);
      setVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setVisible(false);
      }, 4000);
      // Schedule next notification (random between 8-12 seconds + 4s duration)
      const nextDelay = Math.random() * 4000 + 8000 + 4000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-157">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-3 border-l-4 border-teal-500 max-w-xs" data-id="element-158">
        <div className="bg-teal-100 p-2 rounded-full" data-id="element-159">
          <CheckCircle2 className="w-5 h-5 text-teal-600" data-id="element-160" />
        </div>
        <div data-id="element-161">
          <p className="text-sm font-medium text-gray-900" data-id="element-162">{currentName}</p>
          <p className="text-xs text-gray-500" data-id="element-163">acaba de comprar el MegaPack</p>
        </div>
      </div>
    </div>;
}